import React__default from 'react';
import DotSeparated from '../dot-separated/DotSeparated.js';
import { getLorryDetailsByType } from '../../constants/lorryTypes.js';

const LorryOneLineInfo = ({ id = "", size, tyres, capacity, lorryTypeId, dotStyleClassName }) => {
    const currentLorryInfo = getLorryDetailsByType(lorryTypeId);
    return (React__default.createElement("div", null,
        React__default.createElement(DotSeparated, { dotStyleClassName: dotStyleClassName, nodes: [
                React__default.createElement("p", { id: `${id}--lorryType` }, currentLorryInfo === null || currentLorryInfo === void 0 ? void 0 : currentLorryInfo.label),
                ...(capacity
                    ? [
                        React__default.createElement("p", { id: `${id}--capacity`, "data-capacity": capacity },
                            capacity,
                            " ", currentLorryInfo === null || currentLorryInfo === void 0 ? void 0 :
                            currentLorryInfo.unit)
                    ]
                    : []),
                ...(tyres ? [React__default.createElement("p", { id: `${id}--tyres` },
                        tyres,
                        " tyres")] : []),
                ...(size ? [React__default.createElement("p", { id: `${id}--size` },
                        size,
                        " Ft")] : [])
            ] })));
};

export { LorryOneLineInfo as default };
//# sourceMappingURL=LorryOneLineInfo.js.map
